import { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const TelephoneIcon: FC<SvgProps> = ({ fill, ...props }) => {
    const color = fill || 'currentColor'

    return (
        <Svg viewBox="0 0 20 20" width={20} height={20} fill="none" {...props}>
            <Path
                fill={color}
                d="m9.734 13.795.848-.827c.26-.256.633-.342.98-.245.73.214 1.477.377 2.028.48.485.097.838.516.853 1.011l.051 1.972a1.2 1.2 0 0 1-1.282 1.226c-2.584-.2-5.164-1.466-7.14-3.443-1.977-1.977-3.244-4.561-3.443-7.146a1.197 1.197 0 0 1 1.226-1.282l1.971.051c.496.01.915.368 1.012.853.107.547.27 1.297.48 2.028.102.347.01.72-.245.98l-.797.813c.68 1.226 2.176 2.758 3.458 3.53"
            />
            <Path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12.223 10.28c0-.632-.24-1.266-.725-1.751a2.47 2.47 0 0 0-1.752-.725M14.609 10.28a4.84 4.84 0 0 0-1.425-3.437 4.84 4.84 0 0 0-3.438-1.425M16.998 10.281c0-1.854-.71-3.708-2.125-5.123A7.23 7.23 0 0 0 9.75 3.033"
            />
        </Svg>
    )
}

export default TelephoneIcon
